// Generated by scripts/sync-stories.mjs; do not edit by hand.
export const STORY_SLUGS: string[] = ['ba-forecast-scorecard-2015-2026', 'daily-load-profiles-weekday-day-type-weather', 'open-forecaster-43-bas', 'prediction-intervals-winter-storms'];
